import { render } from "./Frontpage.vue?vue&type=template&id=45253316"
import script from "./Frontpage.vue?vue&type=script&lang=js"
export * from "./Frontpage.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhenyan/WebstormProjects/live-data-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__